import React from 'react';
import { motion } from 'framer-motion';

const RecognitionShowcase = () => {
  return (
    <div className="flex justify-center items-center h-[550px]">
      <motion.div
        className="w-full max-w-2xl"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <img 
          src="/lovable-uploads/7d2a5296-0157-4e7e-aadf-4956e315a8bf.png" 
          alt="Recognition showcase with diverse team members celebrating achievements" 
          className="h-auto w-full"
        />
      </motion.div>
    </div>
  );
};

export default RecognitionShowcase;